var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"Path_2346","data-name":"Path 2346","d":"M-14349.646,238.107l3.346-3.474h-25.7v-1.264h25.7l-3.346-3.474.86-.894,4.787,4.974-4.787,5.026Z","transform":"translate(14373 -214.457)","fill":"#0f0f0f","key":0}),React.createElement("rect",{"id":"Rectangle_867","data-name":"Rectangle 867","width":"30","height":"30","fill":"#0f0f0f","opacity":"0","key":1})]);
}

ArrowRight.defaultProps = {"id":"arrow_right_move","data-name":"arrow right move","width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
